/**
 * MM/DD/YY -- the blueprint's one date format, shared by the page header's creation date and the revision log rows.
 * @param date Date (or parseable date string) to format
 * @returns formatted date, empty string when missing or unparseable
 */
export const formatBlueprintDate = (date: Date | string | null | undefined): string => {
	if (!date) return '';
	const parsed = typeof date === 'string' ? new Date(date) : date;
	if (isNaN(parsed.getTime())) return '';
	const month = (parsed.getMonth() + 1).toString().padStart(2, '0');
	const day = parsed.getDate().toString().padStart(2, '0');
	const year = parsed.getFullYear().toString().slice(-2);
	return `${month}/${day}/${year}`;
};
